import { FormControlLabel, styled } from '@mui/material';

import { useForm } from 'react-hook-form';

import { ChangeEvent, memo } from 'react';

import { useI18n } from '@app-velocity/i18n';
import { useUpdateUserDataMutation } from '@app-velocity/modules/users';
import { Form, Checkbox, Typography } from '@app-velocity/ui';

import { NotificationDto } from './dto/NotificationDto';

const StyledNotificationBox = styled('div')<{ loading: boolean }>(
  ({ theme, loading }) => ({
    background: 'var(--info-info-background-color)',
    border: '1px solid var(--info-info-stroke-color)',
    color: 'var(--info-info-text-primary-color)',
    borderRadius: theme.spacing(2),
    padding: theme.spacing(3),
    fontWeight: 500,
    opacity: loading ? 0.5 : 1,
  })
);

const StyledNotificationText = styled(Typography)({
  fontWeight: 500,
  fontSize: 13,
});

export const NotificationBox = memo(() => {
  const { t } = useI18n();

  const { mutate: updateUser, isPending } = useUpdateUserDataMutation();

  const { register } = useForm<NotificationDto>();

  const handleChange = (_: ChangeEvent, checked: boolean) => {
    updateUser({
      marketingAccepted: checked,
    });
  };

  return (
    <StyledNotificationBox loading={isPending}>
      <Form.FieldContainer>
        <Typography>
          <FormControlLabel
            label={
              <StyledNotificationText>
                {t('prototypes:notify_when_its_done')}
              </StyledNotificationText>
            }
            control={
              <Checkbox
                {...register('marketingAccepted')}
                onChange={handleChange}
                inputProps={{
                  // @ts-expect-error https://github.com/mui/material-ui/issues/20160
                  'data-testid': 'email-when-done-checkbox',
                }}
              />
            }
          />
        </Typography>
      </Form.FieldContainer>
    </StyledNotificationBox>
  );
});
